<template>
  <div class="content">
    <h2 class="page-title mb-1">取引申込フォーム</h2>
    <form class="section-wrapper" @submit.prevent="save">
      <validation-observer ref="observer" method="post">
        <company-base-info
          :is-get-data="isCompanyInfoGetData"
          :observer="observer"
          @setData="onSetBaseInfoData"
        />

        <section class="mt-3 apply-tanto">
          <table class="table">
            <tr>
              <th>
                担当部署名
                <span class="must">必須</span>
              </th>
              <td>
                <validation-provider
                  name="TANTO_BUSYO_MEI"
                  v-slot="{ errors }"
                  rules="required|max:20|char"
                >
                  <b-form-input
                    v-model="form.TANTO_BUSYO_MEI"
                    ref="TANTO_BUSYO_MEI"
                    class="col-md-6"
                    maxlength="20"
                    :state="errors.length ? false : null"
                    placeholder="経理部"
                    trim
                    @blur="
                      form.TANTO_BUSYO_MEI = replaceChar(form.TANTO_BUSYO_MEI)
                    "
                  />
                  <b-form-invalid-feedback>
                    <span class="border-red">{{ errors[0] }}</span>
                  </b-form-invalid-feedback>
                </validation-provider>
              </td>
            </tr>
            <tr>
              <th>
                TEL（担当部署）
                <span class="must">必須</span>
              </th>
              <td>
                <validation-provider
                  name="TANTO_BUSYO_TEL"
                  v-slot="{ errors }"
                  rules="required|tel"
                >
                  <b-form-input
                    class="col-md-6"
                    ref="TANTO_BUSYO_TEL"
                    maxlength="17"
                    v-model="form.TANTO_BUSYO_TEL"
                    :state="errors.length ? false : null"
                    placeholder="03-5937-4777"
                    trim
                  />
                  <b-form-invalid-feedback>
                    <span class="border-red">{{ errors[0] }}</span>
                  </b-form-invalid-feedback>
                </validation-provider>
              </td>
            </tr>
            <tr>
              <th>FAX（担当部署）</th>
              <td>
                <validation-provider
                  name="TANTO_BUSYO_FAX"
                  v-slot="{ errors }"
                  rules="fax"
                >
                  <b-form-input
                    class="col-md-6"
                    ref="TANTO_BUSYO_FAX"
                    maxlength="17"
                    v-model="form.TANTO_BUSYO_FAX"
                    :state="errors.length ? false : null"
                    placeholder="03-5937-6666"
                    trim
                  />
                  <b-form-invalid-feedback>
                    <span class="border-red">{{ errors[0] }}</span>
                  </b-form-invalid-feedback>
                </validation-provider>
              </td>
            </tr>
            <tr>
              <th>
                ご担当者名
                <span class="must">必須</span>
              </th>
              <td>
                <div class="row col-md-11">
                  <div class="row col-md-6 pr-md-0">
                    <div class="col-md-1">
                      <label class="mt-2">姓</label>
                    </div>
                    <div class="col-md-10">
                      <validation-provider
                        name="TANTO_MEI_SEI"
                        v-slot="{ errors }"
                        rules="required|max:20|char"
                      >
                        <b-form-input
                          v-model="form.TANTO_MEI_SEI"
                          ref="TANTO_MEI_SEI"
                          maxlength="20"
                          :state="errors.length ? false : null"
                          placeholder="山田"
                          trim
                          @blur="
                            form.TANTO_MEI_SEI = replaceChar(form.TANTO_MEI_SEI)
                          "
                        />
                        <b-form-invalid-feedback>
                          <span class="border-red">{{ errors[0] }}</span>
                        </b-form-invalid-feedback>
                      </validation-provider>
                    </div>
                  </div>
                  <div class="row col-md-6 pr-md-0">
                    <div class="col-md-1">
                      <label class="mt-2">名</label>
                    </div>
                    <div class="col-md-10">
                      <validation-provider
                        name="TANTO_MEI"
                        v-slot="{ errors }"
                        rules="required|max:20|char"
                      >
                        <b-form-input
                          v-model="form.TANTO_MEI"
                          ref="TANTO_MEI"
                          maxlength="20"
                          :state="errors.length ? false : null"
                          placeholder="太郎"
                          trim
                          @blur="form.TANTO_MEI = replaceChar(form.TANTO_MEI)"
                        />
                        <b-form-invalid-feedback>
                          <span class="border-red">{{ errors[0] }}</span>
                        </b-form-invalid-feedback>
                      </validation-provider>
                    </div>
                  </div>
                </div>
              </td>
            </tr>
            <tr>
              <th>
                ご担当者メールアドレス
                <br v-if="isTablet" />
                <span class="must">必須</span>
              </th>
              <td>
                <validation-provider
                  name="TANTO_MAIL_ADDR"
                  v-slot="{ errors }"
                  rules="required|max:50|email"
                >
                  <b-form-input
                    v-model="form.TANTO_MAIL_ADDR"
                    ref="TANTO_MAIL_ADDR"
                    class="col-md-6"
                    maxlength="50"
                    :state="errors.length ? false : null"
                    placeholder="yamada@mail.co.jp"
                    trim
                  />
                  <b-form-invalid-feedback>
                    <span class="border-red">{{ errors[0] }}</span>
                  </b-form-invalid-feedback>
                </validation-provider>
              </td>
            </tr>
            <tr>
              <th>
                担当部署所在地
                <span class="must">必須</span>
              </th>
              <td>
                <div class="row">
                  <div class="col-md-5">
                    <select
                      class="form-control form-input"
                      v-model="form.TANTO_BUSYO_KAISYA_KBN"
                      ref="TANTO_BUSYO_KAISYA_KBN"
                    >
                      <option :value="0">上記企業と同じ</option>
                      <option :value="1">上記企業と異なる</option>
                    </select>
                  </div>
                </div>
              </td>
            </tr>
          </table>
          <table v-if="form.TANTO_BUSYO_KAISYA_KBN" class="table">
            <tr>
              <th>
                正式企業名（担当部署）
                <br v-if="isTablet" />
                <span class="must">必須</span>
              </th>
              <td>
                <validation-provider
                  v-slot="{ errors }"
                  name="TANTO_BUSYO_KAISYA_MEI"
                  rules="required|max:30|char"
                >
                  <b-form-input
                    v-model="form.TANTO_BUSYO_KAISYA_MEI"
                    ref="TANTO_BUSYO_KAISYA_MEI"
                    maxlength="30"
                    class="col-md-6"
                    :state="errors.length ? false : null"
                    placeholder="株式会社ロジコ"
                    trim
                    @blur="
                      form.TANTO_BUSYO_KAISYA_MEI = replaceChar(
                        form.TANTO_BUSYO_KAISYA_MEI
                      )
                    "
                  />
                  <b-form-invalid-feedback>
                    <span class="border-red">{{ errors[0] }}</span>
                  </b-form-invalid-feedback>
                </validation-provider>
              </td>
            </tr>
            <tr>
              <th>
                正式企業名（フリガナ）（担当部署）
                <span class="must">必須</span>
              </th>
              <td>
                <validation-provider
                  v-slot="{ errors }"
                  name="TANTO_BUSYO_KAISYA_MEI_KANA"
                  rules="required|max:50|katakana"
                >
                  <b-form-input
                    v-model="form.TANTO_BUSYO_KAISYA_MEI_KANA"
                    ref="TANTO_BUSYO_KAISYA_MEI_KANA"
                    maxlength="50"
                    class="col-md-6"
                    :state="errors.length ? false : null"
                    placeholder="カブシキガイシャロジコ"
                    trim
                  />
                  <b-form-invalid-feedback>
                    <span class="border-red">{{ errors[0] }}</span>
                  </b-form-invalid-feedback>
                </validation-provider>
              </td>
            </tr>
            <tr>
              <th>郵便番号（担当部署）</th>
              <td>
                <div class="row">
                  <div class="col-4 col-md-3">
                    <validation-provider
                      v-slot="{ errors }"
                      rules="numeric|digits:3"
                      name="TANTO_BUSYO_YUBIN1"
                    >
                      <b-form-input
                        type="tel"
                        ref="TANTO_BUSYO_YUBIN1"
                        maxlength="3"
                        v-model="form.TANTO_BUSYO_YUBIN1"
                        :state="errors.length ? false : null"
                        placeholder="160"
                        trim
                      />
                      <b-form-invalid-feedback>
                        <span class="border-red">{{ errors[0] }}</span>
                      </b-form-invalid-feedback>
                    </validation-provider>
                  </div>
                  <span class="py-2">-</span>
                  <div class="col-4 col-md-3">
                    <validation-provider
                      v-slot="{ errors }"
                      rules="numeric|digits:4"
                      name="TANTO_BUSYO_YUBIN2"
                    >
                      <b-form-input
                        type="tel"
                        ref="TANTO_BUSYO_YUBIN2"
                        maxlength="4"
                        v-model="form.TANTO_BUSYO_YUBIN2"
                        :state="errors.length ? false : null"
                        placeholder="0023"
                        trim
                      />
                      <b-form-invalid-feedback>
                        <span class="border-red">{{ errors[0] }}</span>
                      </b-form-invalid-feedback>
                    </validation-provider>
                  </div>
                  <button
                    type="button"
                    class="btn btn-success bold"
                    @click="searchAddress"
                    :disabled="!isYubinSearch"
                    style="height: 40px"
                  >
                    検索
                  </button>
                </div>
              </td>
            </tr>
            <tr>
              <th>
                都道府県・市区郡（担当部署）
                <span class="must">必須</span>
              </th>
              <td>
                <div class="row">
                  <div class="col-4 col-md-4 col-lg-3 pr-0">
                    <validation-provider
                      v-slot="{ errors }"
                      name="TANTO_BUSYO_TODO_CD"
                      rules="required"
                      ref="TANTO_BUSYO_TODO_MEI"
                    >
                      <b-form-select
                        v-model="form.TANTO_BUSYO_TODO_CD"
                        ref="TANTO_BUSYO_TODO_CD"
                        :state="errors.length ? false : null"
                        :options="prefList"
                        trim
                        @change="changePref"
                      />
                      <b-form-invalid-feedback>
                        <span class="border-red">{{ errors[0] }}</span>
                      </b-form-invalid-feedback>
                    </validation-provider>
                  </div>
                  <div class="col-7 col-md-5 col-lg-4">
                    <validation-provider
                      v-slot="{ errors }"
                      name="TANTO_BUSYO_SHIKU_CD"
                      rules="required"
                      ref="TANTO_BUSYO_SHIKU_MEI"
                    >
                      <b-form-select
                        :disabled="!cityList.length"
                        ref="TANTO_BUSYO_SHIKU_CD"
                        v-model="form.TANTO_BUSYO_SHIKU_CD"
                        :state="errors.length ? false : null"
                        :options="cityList"
                        trim
                        @change="changeCity"
                      />
                      <b-form-invalid-feedback>
                        <span class="border-red">{{ errors[0] }}</span>
                      </b-form-invalid-feedback>
                    </validation-provider>
                  </div>
                </div>
              </td>
            </tr>
            <tr>
              <th>
                町名・番地（担当部署）
                <br v-if="isTablet" />
                <span class="must">必須</span>
              </th>
              <td>
                <validation-provider
                  name="TANTO_BUSYO_BANCHI"
                  v-slot="{ errors }"
                  rules="required|max:25|char"
                >
                  <b-form-input
                    maxlength="25"
                    ref="TANTO_BUSYO_BANCHI"
                    v-model="form.TANTO_BUSYO_BANCHI"
                    :state="errors.length ? false : null"
                    placeholder="西新宿7－4－3 升本ビル4F"
                    trim
                    @blur="
                      form.TANTO_BUSYO_BANCHI = replaceChar(
                        form.TANTO_BUSYO_BANCHI
                      )
                    "
                  />
                  <b-form-invalid-feedback>
                    <span class="border-red">{{ errors[0] }}</span>
                  </b-form-invalid-feedback>
                </validation-provider>
              </td>
            </tr>
          </table>
        </section>

        <seikyu
          class="mt-3"
          :is-lease-flg="true"
          :is-get-data="isSeikyuGetData"
          :observer="observer"
          @setData="onSetSeikyu"
        />

        <section class="mt-5 p-2 p-sm-3 mx-2" id="apply-consent">
          <div class="ml-lg-5 text-left f-size-20 underline">
            <span>
              取引の申し込みにあたり、弊社「
              <a
                href="https://www.logi-co.co.jp/service/rules.pdf"
                target="_blank"
              >
                輸送規約
              </a>
              」「
              <a
                href="https://www.logi-co.co.jp/pdf/personalInfo.pdf"
                target="_blank"
              >
                個人情報取扱いについて
              </a>
              」のご確認、ご同意が必要となります。
            </span>
            <br />
            <span>
              以下の内容をご確認のうえ、ご同意いただける場合はチェックボックスにチェックを入れお申し込みください。
            </span>
          </div>
          <div class="my-3 my-md-5">
            <div class="mt-3 check-box-wrapper">
              <label class="col-md-4 pt-2 bold pc-fs-20">
                輸送規約・免責事項
              </label>
              <md-checkbox
                :class="[
                  'form-check-input md-primary col-md-3',
                  { 'border-red': $v.consent1.$error },
                  { 'pos-relative': isMS },
                ]"
                v-model="consent1"
                :value="true"
              >
                <strong>同意する</strong>
              </md-checkbox>
            </div>
            <div class="row">
              <label class="col-md-5" />
              <div
                v-if="$v.consent1.$error"
                class="err-message ml-5 col-md-5 mt-n2"
              >
                <p v-if="!$v.consent1.required">
                  確認後、チェックをお願いします
                </p>
              </div>
            </div>

            <div class="mt-1 check-box-wrapper">
              <label class="col-md-4 pt-2 bold pc-fs-20">
                個人情報の取り扱い
              </label>
              <md-checkbox
                :class="[
                  'form-check-input md-primary col-md-3',
                  { 'border-red': $v.consent2.$error },
                  { 'pos-relative': isMS },
                ]"
                v-model="consent2"
                :value="true"
              >
                <strong>同意する</strong>
              </md-checkbox>
            </div>
            <div class="row">
              <label class="col-md-5" />
              <div
                v-if="$v.consent2.$error"
                class="err-message ml-5 col-md-5 mt-n2"
              >
                <p v-if="!$v.consent2.required">
                  確認後、チェックをお願いします
                </p>
              </div>
            </div>
          </div>
          <div class="mt-4 ml-lg-5">
            <h5 class="bold pc-fs-20 ml-2">ご請求について</h5>
            <div class="ml-2">
              <div>
                <div class="ml-sm-4">
                  <p>・月初3営業日前後の発送となります。</p>
                  <p>
                    ・【輸送のみ】と【登録輸送を含むご依頼】で請求書が分かれております。同一月に両方ご依頼いただいた場合には、ご請求書原本は2部届きます。
                  </p>
                </div>
              </div>
            </div>
            <h5 class="bold mt-3 pc-fs-20 ml-2">お支払い方法</h5>
            <div class="ml-2">
              <div>
                <div class="ml-sm-4">
                  <p>・月末締め&emsp;翌月末日支払</p>
                </div>
              </div>
            </div>
          </div>
        </section>

        <div class="text-center mt-1 mr-3 mr-md-0">
          <md-button
            type="submit"
            class="btn-lg btn-success base-btn col-md-3 col-lg-2 md-raised"
          >
            申込
          </md-button>
        </div>
      </validation-observer>
    </form>

    <md-snackbar
      :class="snackbar.class"
      md-position="center"
      :md-active.sync="snackbar.isShow"
      md-persistent
    >
      <span>{{ snackbar.text }}</span>
    </md-snackbar>
  </div>
</template>

<script>
import { validationMixin } from 'vuelidate'
import { sameAs } from 'vuelidate/lib/validators'
import Mixin from '../mixin/Mixin'
import CompanyBaseInfo from '@/components/apply/CompanyBaseInfo'
import Seikyu from '@/components/apply/Seikyu'
import Store from '@/store/index.js'
import _ from 'lodash'

export default {
  name: 'Lease',

  mixins: [validationMixin, Mixin],

  components: {
    CompanyBaseInfo,
    Seikyu,
  },

  data: () => ({
    /** オブザーバー */
    observer: null,

    /** 基本情報入力データ取得フラグ */
    isCompanyInfoGetData: false,

    /** 請求先入力データ取得フラグ */
    isSeikyuGetData: false,

    /** スナックバー */
    snackbar: {
      isShow: false,
      class: 'bg-danger',
      text: null,
    },

    /** 市区町村リスト */
    cityList: [],

    /** 同意1 */
    consent1: false,

    /** 同意2 */
    consent2: false,

    /** 入力データ */
    form: {
      LEASE_KAISYA_KBN: 1,
      TORIHIKI_SAKI_MEI: null,
      TORIHIKI_SAKI_MEI_KANA: null,
      TORIHIKI_YUBIN1: null,
      TORIHIKI_YUBIN2: null,
      TORIHIKI_TODO_MEI: null,
      TORIHIKI_TODO_CD: null,
      TORIHIKI_SHIKU_MEI: null,
      TORIHIKI_BANCHI: null,
      TORIHIKI_SHIKU_CD: null,
      TORIHIKI_SAKI_TEL: null,
      TORIHIKI_SAKI_FAX: null,
      TANTO_BUSYO_MEI: null,
      TANTO_BUSYO_TEL: null,
      TANTO_BUSYO_FAX: null,
      TANTO_MEI_SEI: null,
      TANTO_MEI: null,
      TANTO_MAIL_ADDR: null,
      TANTO_BUSYO_KAISYA_KBN: 0,
      TANTO_BUSYO_KAISYA_MEI: null,
      TANTO_BUSYO_KAISYA_MEI_KANA: null,
      TANTO_BUSYO_YUBIN1: null,
      TANTO_BUSYO_YUBIN2: null,
      TANTO_BUSYO_TODO_CD: null,
      TANTO_BUSYO_TODO_MEI: null,
      TANTO_BUSYO_SHIKU_CD: null,
      TANTO_BUSYO_SHIKU_MEI: null,
      TANTO_BUSYO_BANCHI: null,
      SEIKYU_SAKI_KBN: false,
      SKS_KAISYA: null,
      SKS_KAISYA_KANA: null,
      SKS_BUSYO_MEI: null,
      SKS_YUBIN1: null,
      SKS_YUBIN2: null,
      SKS_TODO_CD: null,
      SKS_TODO_MEI: null,
      SKS_SHIKU_CD: null,
      SKS_SHIKU_MEI: null,
      SKS_BANCHI: null,
      SKS_TEL: null,
      SKS_FAX: null,
    },
  }),

  /** バリデーションルール */
  validations() {
    let valid = {
      consent1: {
        sameAs: sameAs(() => true),
      },
      consent2: {
        sameAs: sameAs(() => true),
      },
    }
    return valid
  },

  mounted() {
    this.observer = this.$refs.observer
  },

  methods: {
    /** 都道府県変更 */
    changePref() {
      const todoCd = this.form.TANTO_BUSYO_TODO_CD
      this.form.TANTO_BUSYO_TODO_MEI = null
      this.form.TANTO_BUSYO_SHIKU_CD = ''
      this.form.TANTO_BUSYO_SHIKU_MEI = null
      if (todoCd) {
        this.form.TANTO_BUSYO_TODO_MEI = this.getText(this.prefList, todoCd)
        this.getCityList()
      } else this.cityList = []
    },

    /** 市区町村変更 */
    changeCity() {
      const shikuCd = this.form.TANTO_BUSYO_SHIKU_CD
      this.form.TANTO_BUSYO_SHIKU_MEI = null
      if (shikuCd) {
        this.form.TANTO_BUSYO_SHIKU_MEI = this.getText(this.cityList, shikuCd)
      }
    },

    /** 市区町村リスト取得 */
    getCityList() {
      if (!this.form.TANTO_BUSYO_TODO_CD) return
      return Store.dispatch(
        'address/getCityList',
        this.form.TANTO_BUSYO_TODO_CD
      ).then(() => {
        const cityList = _.cloneDeep(Store.state.address.cityList)
        cityList.unshift({
          value: '',
          text: '未選択',
        })
        this.cityList = cityList
      })
    },

    /** 郵便番号検索 */
    searchAddress() {
      this.getAreaFromZipCd(
        `${this.form.TANTO_BUSYO_YUBIN1}${this.form.TANTO_BUSYO_YUBIN2}`
      ).then(async (item) => {
        if (item) {
          this.form.TANTO_BUSYO_TODO_CD = ('00' + item.prefcode).slice(-2)
          this.form.TANTO_BUSYO_TODO_MEI = this.getText(
            this.prefList,
            this.form.TANTO_BUSYO_TODO_CD
          )
          this.form.TANTO_BUSYO_SHIKU_MEI = item.address2
          this.form.TANTO_BUSYO_BANCHI = item.address3
          await this.getCityList()
          const city = this.getParam(
            this.cityList,
            this.form.TANTO_BUSYO_SHIKU_MEI,
            'text'
          )
          if (city) this.form.TANTO_BUSYO_SHIKU_CD = city.value
        }
      })
    },

    /** データを登録する */
    async save() {
      if (this.uploadcount !== this.uploadedcount) {
        this._alert('ファイルのアップロードが完了していません。')
        return
      }

      // バリデーション
      this.$v.$touch()
      const validResult = await this.observer.validate()
      if (!validResult || this.$v.$invalid) {
        this.spinerOff()
        return this._alert('入力項目にエラーがあります。')
      }

      this.spinerOn()
      this.cleanup()
      await this.getAllData()

      // データ登録API
      this.$store
        .dispatch('tmpTorihiki/post', this.form)
        .then((res) => {
          this.$router.push({ name: 'ApplyComplete' })
        })
        .catch((err) => {
          this.consent1 = false
          this.consent2 = false
          this.snackbar.text = 'エラーが発生しました code: 002'
          this.snackbar.isShow = true
        })
        .finally(() => this.spinerOff())
    },

    /** 表示された入力データのみ設定する */
    cleanup() {
      let d = _.cloneDeep(this.form)
      for (var name in d) {
        d[name] = this.$refs[name] ? d[name] : null
      }
      d['LEASE_KAISYA_KBN'] = 1
      this.form = d
    },

    // 子コンポーネントの入力データを取得する
    async getAllData() {
      this.isCompanyInfoGetData = true
      this.isSeikyuGetData = true
      await this.sleep(50)
    },

    /** データをマージする */
    mergeForm(val) {
      if (val) {
        let data = {}
        for (const name in val) {
          if (this.form.hasOwnProperty(name)) data[name] = val[name]
        }
        _.merge(this.form, data)
      }
    },

    /** baseinfoの入力データをマージする */
    onSetBaseInfoData(val) {
      this.mergeForm(val)
      this.isCompanyInfoGetData = false
    },

    /** 請求先の入力データをマージする */
    onSetSeikyu(val) {
      this.mergeForm(val)
      this.isSeikyuGetData = false
    },
  },

  computed: {
    /** 郵便検索可能か */
    isYubinSearch() {
      return (
        this.form.TANTO_BUSYO_YUBIN1 &&
        this.form.TANTO_BUSYO_YUBIN2 &&
        this.observer &&
        this.observer.fields.TANTO_BUSYO_YUBIN1 &&
        this.observer.fields.TANTO_BUSYO_YUBIN2 &&
        !this.observer.fields.TANTO_BUSYO_YUBIN1.failed &&
        !this.observer.fields.TANTO_BUSYO_YUBIN2.failed
      )
    },
  },
}
</script>

<style lang="sass" scoped>
@import '../../assets/css/logico2'
.md-raised
  background: $baseGreenColor !important
.section-wrapper
  background: $baseGrayColor
  padding: 1%
table
  margin: 0
  th
    background: $baseBlueColor
    color: #fff
    width: 32%
    padding: 1.5%
  td
    width: 68%
    background: #fff
section#apply-consent
  margin: 20px auto
  background: $baseGrayColor
  border: 5px solid $baseBlueColor
  .check-box-wrapper
    margin-left: 20%
</style>



// WEBPACK FOOTER //
// src/components/apply/Lease.vue